import React, { FC, memo } from 'react'
import { useMovableModal } from 'hooks/modal/movable/useMovableModal'
import './MovableModal.scss'
import cs from 'classnames'

interface IProps {
  visible: boolean
  hidden?: boolean,
  width?: number,
  height?: number,
  withBackground?: boolean
  restorePosition?: boolean
  background?: string,
  onCloseWindow?: () => void
  windowId: string
  pointerEvents?: boolean
}

export const MovableModalContainer: FC<IProps> = memo(({
  children,
  visible,
  hidden,
  withBackground,
  width = 640,
  height = 520,
  restorePosition = true,
  onCloseWindow,
  background,
  windowId,
  pointerEvents = true,
}) => {
  const { movableContainerRef, isMouseDown, overlayRef, childRef } = useMovableModal({
    visible, width, height, restorePosition, onCloseWindow, windowId,
  })
  if (!visible) return null

  const childWithRef = React.isValidElement(children)
    ? React.cloneElement(children, { ref: childRef })
    : children

  return (
    <div
      className={cs('movable-modal', {
        background: withBackground,
        active: visible,
        hidden,
        'pointer-events': pointerEvents,
      })}
      ref={overlayRef}
    >
      <div
        ref={movableContainerRef}
        className={cs('movable-modal__container', {
          move: isMouseDown,
          active: visible,
        })}
        style={{ width, height, background }}
        data-id="container"
      >
        {childWithRef}
      </div>
    </div>
  )
})
